import { render, staticRenderFns } from "./SoftnetButton.vue?vue&type=template&id=29635e8e&"
import script from "./SoftnetButton.vue?vue&type=script&lang=js&"
export * from "./SoftnetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports